/**
 * @deprecated This file is deprecated. Use @starjack/utils instead.
 */

import { Locale } from '@/models/system';

/**
 * @deprecated Use isDevelopment from @starjack/utils instead.
 */
export const isDevelopment =
    process.env.BUILD_MODE === 'development' ||
    process.env.BUILD_MODE === 'staging';

if (isDevelopment) {
    console.warn('Running in development mode');
    console.warn(process.env.BUILD_MODE);
}

/**
 * @deprecated Use APP_VERSION from @starjack/utils instead.
 */
export const APP_VERSION = '0.0.1';

/**
 * @deprecated Use API from @starjack/utils instead.
 */
export const API = isDevelopment
    ? 'https://api.staging.starjack.at/'
    : 'https://api.starjack.at/';

console.warn('using API', API);

/**
 * @deprecated Use DEFAULT_API_VERSION from @starjack/utils instead.
 */
export const DEFAULT_API_VERSION = 'v1/';
/**
 * @deprecated Use LOCAL_STORAGE_KEY from @starjack/utils instead.
 */
export const LOCAL_STORAGE_KEY = 'starjackAdmin';

// localstorage nodes
/**
 * @deprecated Use LOCAL_STORAGE_KEY_AUTH from @starjack/utils instead.
 */
export const LOCAL_STORAGE_KEY_AUTH = 'auth';

/**
 * @deprecated Use DATE_FORMAT from @starjack/utils instead.
 */
export const DATE_FORMAT = 'dd.MM.yyyy';
/**
 * @deprecated Use DATE_TIME_FORMAT from @starjack/utils instead.
 */
export const DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';

/**
 * @deprecated Use DATE_FORMAT_BACKEND_STRING from @starjack/utils instead.
 */
export const DATE_FORMAT_BACKEND_STRING = 'yyyy-MM-dd';

/**
 * @deprecated Use WEEKDAYS from @starjack/utils instead.
 */
export const WEEKDAYS = {
    MONDAY: 'Montag',
    TUESDAY: 'Dienstag',
    WEDNESDAY: 'Mittwoch',
    THURSDAY: 'Donnerstag',
    FRIDAY: 'Freitag',
    SATURDAY: 'Samstag',
    SUNDAY: 'Sonntag',
};

/**
 * @deprecated Use ACCEPTED_FILES_IMAGE from @starjack/utils instead.
 */
export const ACCEPTED_FILES_IMAGE = {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
};

/**
 * @deprecated Use locale from @starjack/utils instead.
 */
export const locale = Locale.DE;
